import * as React from 'react';
import { BaSeStaticAsset } from '../static-asset/static-asset';
import { ImageProps } from './image-props';

export const BaSeImageMap: React.FC<
  Pick<ImageProps, 'name' | 'description'>
> = ({ name, description }) => (
  <BaSeStaticAsset
    classIdentifier="BaSe--image-map"
    description={description}
    path={`images/maps/${name}.svg`}
  />
);

BaSeImageMap.displayName = 'BaSeImageMap';
